<template>
  <div class="bed-status-page">
    <!-- 顶部区域 -->
    <div class="top-fixed">
      <!-- 搜索框 -->
      <van-search
          v-model="searchKeyword"
          placeholder="输入科室名称"
          clearable
          background="#ffffff"
          @input="onSearchInput"
      />

      <!-- Tab 栏 -->
      <van-tabs
          v-model="activeTab"
          @click="onTabClick"
          color="#7ed320"
          :swipeable="false"
      >
        <van-tab title="全部科室" name="all"></van-tab>
        <van-tab
            v-for="dept in allDepartments"
            :key="dept.ksbm"
            :title="dept.ksmc"
            :name="dept.ksmc"
        ></van-tab>
      </van-tabs>
    </div>

    <!-- 内容滚动区 -->
    <div class="scroll-content">
      <!-- 全局统计卡片 -->
      <div class="global-stats">
        <div class="stat-card">
          <div class="icon green"><van-icon name="success" size="24" /></div>
          <div class="value">{{ totalEmptyBeds }}</div>
          <div class="label">空床数量</div>
        </div>
      </div>

      <!-- 各科室详情 -->
      <div
          v-for="item in displayedData"
          :key="item.ksbm"
          class="dept-detail"
      >
        <div class="dept-header">
          <h3>{{ item.ksmc }}</h3>
          <div class="info-tags">
            <span class="tag empty">空床 {{ item.kcw }}/{{ item.zcw }}</span>
          </div>
        </div>

        <div class="progress-group">
          <div class="progress-item">
            <span class="label">床位使用率</span>
            <van-progress
                :percentage="Math.round((item.yzcw / item.zcw) * 100)"
                :stroke-width="6"
                color="#409eff"
            />
            <span class="label">{{ Math.round((item.yzcw / item.zcw) * 100) }}%</span>
          </div>
          <div class="progress-item">
            <span class="label">预计空床率</span>
            <van-progress
                :percentage="Math.round((item.kcw / item.zcw) * 100)"
                :stroke-width="6"
                color="#7ed320"
            />
            <span class="label">{{ Math.round((item.kcw / item.zcw) * 100) }}%</span>
          </div>
        </div>
      </div>

      <div v-if="displayedData.length === 0" class="no-data">
        暂无相关科室床位信息
      </div>
    </div>
  </div>
</template>

<script>
import {getChuangwgs} from "@/api/hdTCM";

export default {
  name: 'BedStatus',
  data() {
    return {
      searchKeyword: '',
      activeTab: 'all',
      departmentList: []
    };
  },

  mounted() {
    getChuangwgs().then(res => {
      if(res.success){
        this.departmentList=res.result;
      }
    })
  },

  computed: {
    allDepartments() {
      return this.departmentList;
    },

    displayedData() {
      let list = this.departmentList;

      if (this.activeTab !== 'all') {
        list = list.filter(item => item.ksmc === this.activeTab);
      }

      const keyword = this.searchKeyword.trim().toLowerCase();
      if (keyword) {
        list = list.filter(item =>
            item.ksmc.toLowerCase().includes(keyword) ||
            item.ksbm.toLowerCase().includes(keyword)
        );
      }

      return list;
    },

    // 全局统计
    totalEmptyBeds() {
      return this.displayedData.reduce((sum, item) => sum + item.kcw, 0);
    },
  },

  methods: {
    onSearchInput() {
      if (this.activeTab !== 'all') {
        this.activeTab = 'all';
      }
    },

    onTabClick(name) {
      this.activeTab = name;
    }
  }
};
</script>

<style scoped>
/*外层div*/
.bed-status-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8fafc;
  overflow: hidden;
}
/*顶部区域*/
.top-fixed {
  width: 100%;
  height: 100px;
  background: #ffffff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  z-index: 1000;
  display: flex;
  flex-direction: column;
}

.top-fixed ::v-deep .van-search {
  padding: 6px 12px;
  margin: 12px 12px 0;
}

.scroll-content {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
  box-sizing: border-box;
}

/* 全局统计卡片 */
.global-stats {
  display: flex;
  gap: 12px;
  margin-bottom: 10px;
  padding: 10px 0;
}

.stat-card {
  flex: 1;
  background: #ffffff;
  border-radius: 12px;
  padding: 12px;
  text-align: center;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.stat-card .icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.stat-card .value {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
}

.stat-card .label {
  font-size: 12px;
  color: #6c757d;
}

.green { color: #7ed320; }

/* 科室详情 */
.dept-detail {
  background: #ffffff;
  border-radius: 12px;
  margin-bottom: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.dept-header {
  padding: 16px 16px 8px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dept-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
}

.info-tags {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  letter-spacing: 1px;
}

.tag {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  background: #ecfeff;
  color: #7ed320;
}

.progress-group {
  padding: 12px 16px;
}

.progress-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
}
/*label和value*/
.progress-item .label {
  font-size: 13px;
  color: #6c757d;
}
/*进度条*/
.van-progress {
  width: calc(100% - 112px)
}

.no-data {
  text-align: center;
  color: #999;
  padding: 30px 0;
  font-size: 14px;
}
</style>